import { Link, useNavigate } from 'react-router-dom';
import { ValidMessageFormValue } from '#/components/ui/messages/model/messageForm';
import { MessageEditor } from '#/components/ui/messages/MessageEditor/MessageEditor';
import { ActionIcon, Anchor, Group, Stack, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import {
  useMessageCreatePresetStorage,
  useWithPresetParam,
} from '#/components/ui/messages/hooks/useMessagePreset';
import { useCreateMessageTemplate } from '#/components/ui/messages/endpoints';

const MessageCreatePage = () => {
  const navigate = useNavigate();
  const { shouldWithPreset } = useWithPresetParam();

  const { preset } = useMessageCreatePresetStorage();

  const { mutate } = useCreateMessageTemplate();

  const handleSubmit = (values: ValidMessageFormValue) => {
    mutate(values);

    navigate('/messages');
  };

  return (
    <Stack>
      <Anchor
        component={Link}
        to="/messages"
        w="fit-content"
        c="dimmed"
        fw={500}
      >
        <Group gap={6}>
          <ActionIcon variant="transparent" color="gray" size="sm">
            <IconArrowLeft size={16} />
          </ActionIcon>
          <Text size="sm">返回訊息管理頁</Text>
        </Group>
      </Anchor>
      <MessageEditor
        initialValues={shouldWithPreset ? preset : undefined}
        handleSubmit={handleSubmit}
      />
    </Stack>
  );
};

export default MessageCreatePage;
